/**
 * Zakres dat po ludzku, wspólny dla obu raportów: pełny miesiąc → „czerwiec 2026", zakres w jednym
 * miesiącu → „1–14 czerwca 2026" itd. Odpowiada `SlidesMetaBuilder.formatPeriodLabel` z workera.
 * Daty są bez czasu (yyyy-mm-dd), więc parsujemy i formatujemy w UTC — inaczej strefa przesuwa dzień.
 */
export const formatPeriodLabel = (
  periodFrom: string,
  periodTo: string,
  locale: string
): string => {
  const from = new Date(`${periodFrom}T00:00:00Z`);
  const to = new Date(`${periodTo}T00:00:00Z`);
  const utc = { timeZone: 'UTC' } as const;
  const monthYear = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', ...utc });
  const dayMonthYear = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...utc,
  });
  const dayMonth = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', ...utc });
  const dayOnly = new Intl.DateTimeFormat(locale, { day: 'numeric', ...utc });

  const sameYear = from.getUTCFullYear() === to.getUTCFullYear();
  const sameMonth = sameYear && from.getUTCMonth() === to.getUTCMonth();
  const lastDayOfToMonth = new Date(
    Date.UTC(to.getUTCFullYear(), to.getUTCMonth() + 1, 0)
  ).getUTCDate();

  if (sameMonth && from.getUTCDate() === 1 && to.getUTCDate() === lastDayOfToMonth) {
    return monthYear.format(from);
  }
  if (sameMonth) {
    return `${dayOnly.format(from)}–${dayMonthYear.format(to)}`;
  }
  if (sameYear) {
    return `${dayMonth.format(from)} – ${dayMonthYear.format(to)}`;
  }
  return `${dayMonthYear.format(from)} – ${dayMonthYear.format(to)}`;
};

/** Locale pod `formatPeriodLabel` z języka i18n — panel ma tylko PL i EN. */
export const periodLocaleFor = (language?: string): string =>
  language?.startsWith('pl') ? 'pl' : 'en-GB';
